module.exports = __webpack_public_path__ + "img/1F1EE-1F1F3.45182559.svg";